import { useState, useEffect } from 'react';
import { useMutation } from 'react-query';
import { showNotification } from '../../../actions/index';
import { api } from '../../../api';

export const useUpdateDQPAddedDelays = ({
  frichtiDqpExtraAddedDelay,
  frichtiDqpNearbyExtraAddedDelay,
  centerDqpExtraAddedDelay,
  centerDqpNearbyExtraAddedDelay,
  currentCenterId,
  dispatch,
}) => {
  const [frichtiAddedDelay, setFrichtiAddedDelay] = useState(frichtiDqpExtraAddedDelay || 0);
  const [frichtiNearbyAddedDelay, setFrichtiNearbyAddedDelay] = useState(frichtiDqpNearbyExtraAddedDelay || 0);
  const [centerAddedDelay, setCenterAddedDelay] = useState(centerDqpExtraAddedDelay || 0);
  const [centerNearbyAddedDelay, setCenterNearbyAddedDelay] = useState(centerDqpNearbyExtraAddedDelay || 0);

  useEffect(() => {
    setFrichtiAddedDelay(frichtiDqpExtraAddedDelay);
  }, [frichtiDqpExtraAddedDelay]);

  useEffect(() => {
    setFrichtiNearbyAddedDelay(frichtiDqpNearbyExtraAddedDelay);
  }, [frichtiDqpNearbyExtraAddedDelay]);

  useEffect(() => {
    setCenterAddedDelay(centerDqpExtraAddedDelay);
  }, [centerDqpExtraAddedDelay]);

  useEffect(() => {
    setCenterNearbyAddedDelay(centerDqpNearbyExtraAddedDelay);
  }, [centerDqpNearbyExtraAddedDelay]);

  const [mutateSetAddedDelay, { isLoading: isAddedDelayLoading }] = useMutation(({
    centerId, siteId, payload
  }) => (
    api.updateCenterSiteDQPDelays(centerId, siteId, payload)
  ),
  {
    onSuccess: (data, { siteId, payload }) => {
      const resolveLabel = () => {
        if (payload.hasOwnProperty("dqp_extra_added_delay")) {
          return `${siteId === 1013 ? 'Frichti Market' : ''} Délais DQP IDF`;
        } else if (payload.hasOwnProperty("dqp_nearby_extra_added_delay")) {
          return `${siteId === 1013 ? 'Frichti Market' : ''} Délais DQP Proche`;
        }
      };

      const resolveValue = () => {
        if (payload.hasOwnProperty("dqp_extra_added_delay")) {
          return payload.dqp_extra_added_delay;
        } else if (payload.hasOwnProperty("dqp_nearby_extra_added_delay")) {
          return payload.dqp_nearby_extra_added_delay;
        }
      };

      const label = resolveLabel() || "DQP setting";
      const value = resolveValue();

      dispatch(showNotification('success', {
        title: label,
        message: `${label}: ${value} mis à jour avec succès`,
        autoDismiss: 10,
        dismissible: "click",
      }));
    },
    onError: (error) => {
      console.error("Error updating DQP added delays:", error);
      dispatch(showNotification('error', {
        title: 'Erreur',
        message: `Une erreur est survenue lors de la mise à jour des délais DQP.`,
        autoDismiss: 10,
        dismissible: "click",
      }));
    },
  });

  const onSaveFrichtiAddedDelay = () => {
    mutateSetAddedDelay({
      centerId: currentCenterId,
      siteId: 1013,
      payload: {
        dqp_extra_added_delay: parseInt(frichtiAddedDelay, 10),
      },
    });
  };

  const onSaveFrichtiNearbyAddedDelay = () => {
    mutateSetAddedDelay({
      centerId: currentCenterId,
      siteId: 1013,
      payload: {
        dqp_nearby_extra_added_delay: parseInt(frichtiNearbyAddedDelay, 10),
      },
    });
  };

  const onSaveCenterAddedDelay = () => {
    mutateSetAddedDelay({
      centerId: currentCenterId,
      payload: {
        dqp_extra_added_delay: parseInt(centerAddedDelay, 10),
      },
    });
  };

  const onSaveCenterNearbyAddedDelay = () => {
    mutateSetAddedDelay({
      centerId: currentCenterId,
      payload: {
        dqp_nearby_extra_added_delay: parseInt(centerNearbyAddedDelay, 10),
      },
    });
  };

  return {
    frichtiAddedDelay,
    setFrichtiAddedDelay,
    frichtiNearbyAddedDelay,
    setFrichtiNearbyAddedDelay,
    centerAddedDelay,
    setCenterAddedDelay,
    centerNearbyAddedDelay,
    setCenterNearbyAddedDelay,
    onSaveFrichtiAddedDelay,
    onSaveFrichtiNearbyAddedDelay,
    onSaveCenterAddedDelay,
    onSaveCenterNearbyAddedDelay,
    // isAddedDelayLoading,
  };
};

export default useUpdateDQPAddedDelays;